import { BaseEntity } from "./BaseEntity";
// Type-only, so it is erased at compile time and the mutual reference between these two
// modules never reaches the bundle. Spelt out to keep it that way.
import type { CourseVersion } from "./CourseVersion";
import { Curriculum } from "./Curriculum";

export enum COURSE_STATUS {
    ACTIVE = 'ACTIVE',
    LEGACY = 'LEGACY',
    RETIRED = 'RETIRED',
    COMING_SOON = 'COMING_SOON',
    RE_SKUED = 'RE_SKUED'
}

export interface Course extends BaseEntity {
    name: string;
    sku: string;
    status: COURSE_STATUS;
    curriculum: Curriculum;
    isCertification: boolean;
    certification: Course | undefined | null;
    /**
     * A bundled SKU: one product number covering a course and its exam together. The two halves
     * are held apart - `bundleCourse` is the course, `certification` the exam - so a bundle that
     * says it is one carries both.
     */
    isBundle: boolean;
    bundleCourse: Course | undefined | null;
    versions: CourseVersion[];
    latestVersion?: CourseVersion;
}